import * as React from 'react';

import { MessageBar, MessageBarType } from '@fluentui/react';
import { BuildInfo } from './Page';

export interface ErrorBoundaryProps {
  buildInfo?: BuildInfo;
  children?: React.ReactNode;
}

export interface ErrorBoundaryState {
  error?: Error;
  errorInfo?: React.ErrorInfo;
}

export class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = {};
  }

  public render(): JSX.Element {
    if (this.state.error) {
      return (
        <div role="alert" style={{ margin: 20 }}>
          <MessageBar messageBarType={MessageBarType.error} isMultiline={true}>
            You have encountered a client side error.
          </MessageBar>
          {this.props.buildInfo && (
            <pre style={{ marginTop: 20 }}>
              <code>{JSON.stringify(this.props.buildInfo, null, 4)}</code>
            </pre>
          )}
          <pre style={{ marginTop: 20 }}>
            <code>{this.state.error.message}</code>
          </pre>
          <pre style={{ marginTop: 20 }}>
            <code>{this.state.error.stack || '<no stack trace>'}</code>
          </pre>
        </div>
      );
    }
    return this.props.children as JSX.Element;
  }

  public componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    this.trackError(error, errorInfo);
  }

  private trackError(error: Error, errorInfo: React.ErrorInfo) {
    this.setState({ error, errorInfo });
  }
}
